import { render } from "./accept.vue?vue&type=template&id=001244d2"
import script from "./accept.vue?vue&type=script&lang=js"
export * from "./accept.vue?vue&type=script&lang=js"

import "./accept.vue?vue&type=style&index=0&id=001244d2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__